import { IEntriesProps, useContentful } from '@smuchile/pkg-unimarc-hooks'

interface IConnectionCfBenefits {
  dataBenefitsCF?: IEntriesProps
}

const ConnectionCfBenefits = ({
  include
}: { include?: number } = {}): IConnectionCfBenefits => {
  const { data: dataBenefitsCF } = useContentful({
    id_contentful: `Club-Benefits-${include}`,
    options: {
      content_type: 'featureContentBanners',
      'fields.label[match]': 'Beneficios por nivel mobile | Club Unimarc WEB',
      include
    },
    reactQuery: {
      enabled: true,
      retry: 3,
      staleTime: 1000 * 60 * 5,
      refetchOnWindowFocus: false
    }
  })

  return {
    dataBenefitsCF
  }
}

export { ConnectionCfBenefits }
